/**
 * Should be kept updated with column Name from billingproduct table in DB.
 */
export enum BillingProductNameEnum {
  Pos = 'POS',
  Kiosk = 'Kiosk',
  Gigable = 'Gigable',
  Loyalty = 'Loyalty',
  ReputationManagement = 'Reputation Management',
  JustEat = 'Just Eat',
  Deliveroo = 'Deliveroo',
  GiftCard = 'Gift Card',
  AdminONE = 'Admit ONE',
  OnlineOrdering = 'Online Ordering',
  UberEats = 'Uber Eats',
  StockManagement = 'Stock Management',
  Purchasing = 'Purchasing',
  RecipeManagement = 'Recipe Management',
  CashUp = 'Cash Up',
  InactiveProduct = 'Inactive Product',
  InactiveIntegration = 'Inactive Integration',
  BOICollect = 'BOI Collect',
  UltraOrder = 'Ultra Order',
  Vectron = 'Vectron',
  SweetFace = 'Sweet Face',
  Synergy = 'Synergy'
}
